module.exports = __webpack_public_path__ + "static/media/fa-brands-400.5c5f6302.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-brands-400.ttf
// module id = 731
// module chunks = 0